
import React from 'react';
import { AlertCircle, AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface ResetPasswordErrorProps {
  error: string | null;
  rateLimited: boolean;
}

const ResetPasswordError: React.FC<ResetPasswordErrorProps> = ({ error, rateLimited }) => {
  if (!error) return null;
  
  return (
    <Alert variant={rateLimited ? "warning" : "destructive"}>
      {rateLimited ? <AlertTriangle className="h-4 w-4" /> : <AlertCircle className="h-4 w-4" />}
      <AlertDescription>{error}</AlertDescription>
    </Alert>
  );
};

export default ResetPasswordError;
